module.exports = __webpack_public_path__ + "static/media/b6b1d9ba-96bb-479d-a1fd-f31e6003a905_1.dd525ee2c941fe2f7e7d27549bc4ddcf.89603a4b.jpeg";